const Invoice = {
    "invoices": "Invoices",
    "search": "Search",
    "premise": "Premise",
    "unit": "Unit",
    "invoice_status": "Invoice Status",
    "date_from": "From Date",
    "date_to": "To Date",
    "status_paid": "Paid",
    "status_unpaid": "Unpaid",
    "status_partial": "Partial",
    "preview": "Preview PDF",
    "pdf_unavailable": "No PDF is available for this invoice.",
    "pdf_popup_blocked": "Unable to open the PDF. Allow pop-ups for this site or try again.",

    "table_invoice_no": "INVOICE NO.",
    "table_premise": "PREMISE",
    "table_unit": "UNIT",
    "table_invoice_date": "INVOICE DATE",
    "table_due_date": "DUE DATE",
    "table_amount": "AMOUNT",
    "table_status": "STATUS",
}

export default Invoice;